import types from "./types";
import { encryptEstandar } from "../../Utils/CryptographyUtils";

const initialState = {
  username: null,
  idClient: null,
  granted: false,
  access_configuration: null,
  channel: null,
  firstName:  null,
};

const loginReducer = (state = initialState, action) => {
  const {
    type,
    username,
    idClient,
    access_configuration,
    channel,
    first
  } = action;
  
  switch (type) {
    case types.accessGranted:
      const idClientTemp = encryptEstandar(idClient);
      const usernameTemp = encryptEstandar(username);
      return {
        username: usernameTemp,
        idClient: idClientTemp,
        access_configuration,
        granted: true,
        channel,
        firstName:first,
      };
    case types.logout:
      return {
        username: null,
        idClient: null,
        granted: false,
        access_configuration: null,
        channel: null,
        firstName:null
      };
    default:
      return {
        ...state
      };
  }
};
export default loginReducer;
